// Module: useFetchDateRange
// Purpose: Compute historic prefetch window for live/paper deep-dive chart.

import { useMemo } from 'react';
import moment from 'moment';

const WINDOW_DAYS = {
  '1D': 30,
  '4H': 30,
  '1H': 7,
  '30m': 7,
  '15m': 7,
  '5m': 2,
  '1m': 2,
};

export function useFetchDateRange({ mode, timeframe, lastObservedTickTime = null }) {
  return useMemo(() => {
    if (mode !== 'live' && mode !== 'paper') return null;
    const days = WINDOW_DAYS[timeframe] ?? 7;
    //! When a simulated/historic tick time is provided, anchor the window to that
    //! time instead of wall-clock now(). This keeps the chart centred on the
    //! replay session (e.g. Jan 12) rather than today (e.g. Apr 14).
    const end = lastObservedTickTime ? moment(lastObservedTickTime) : moment();
    const start = end.clone().subtract(days, 'days');
    return { start, end };
  }, [mode, timeframe, lastObservedTickTime]);
}
